import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AppLink from '../shared/AppLink';
import SubMenuList from './SubMenuList';
import Collapse from '../shared/Collapse';
import { ArrowRoundedDown9x6Svg } from '../../svg';

function Menu(props) {
    const {
        layout,
        withIcons,
        items,
        isMegaMenu,
        onClick,
        isActive,
    } = props;

    const renderLink = (item, content) => {
        let link;
        if (item.url && item.otherSource === false) {
            link = (
                <Fragment>
                    {
                        item.isClicked === true ? (
                            <AppLink
                                className="colum-title"
                                {...item.props}
                                to={item.url}
                                target={item.targeti}
                                onClick={() => onClick(item)}
                            >
                                {content}
                            </AppLink>
                        ) : (
                            <span className="colum-title cursor-default" {...item.props}>
                                {content}
                            </span>
                        )
                    }
                </Fragment>
            );
        } else if (item.url && item.otherSource === true) {
            link = (
                <a
                    className="colum-title"
                    href={item.url}
                    target={item.targeti}
                    name="link"
                    aria-label="link"
                >
                    {item.pageName}
                </a>
            );
        } else {
            link = <button aria-label="navigation" name="navigation button" type="button" onClick={() => onClick(item)}>{content}</button>;
        }

        return link;
    };

    const itemsList = items.map((item, index) => {
        const renderCategory = (
            {
                toggle, setItemRef, setContentRef,
            },
        ) => {
            let expander;
            let arrow;
            let submenu;
            let icon;

            if (item.submenu && item.submenu.length) {
                expander = <ArrowRoundedDown9x6Svg width="20px" height="20px" className="widget-categories__arrow" onClick={toggle} />;
                submenu = (
                    <div className={(isActive, 'colon-childs')} ref={setContentRef}>
                        <SubMenuList items={item.submenu} onClick={() => onClick(item)} isActive={isActive} />
                    </div>
                );
            }

            if (withIcons && item.icon) {
                icon = (
                    <div className="menu__icon">
                        <img src={item.icon} srcSet={item.icon_srcset} alt="" />
                    </div>
                );
            }

            const classesMegaMenu = classNames(isMegaMenu === true ? 'colum-box' : 'col colum-box'); return (
                <div className={classesMegaMenu} key={index} ref={setItemRef}>
                    <div className="colum-content">
                        {renderLink(item, (
                            <React.Fragment>
                                {icon}
                                {item.pageName}
                                {arrow}
                            </React.Fragment>
                        ))}
                        <div>
                            {expander}
                        </div>
                    </div>
                    {submenu}
                </div>
            );
        };
        return <Collapse key={index} toggleClass="menu__item--open" render={renderCategory} />;
    });

    const classes = classNames(`menu menu--layout--${layout}`, {
        'menu--with-icons': withIcons,
    });

    return (
        <div className={classes}>
            <div className="mega-colums">
                {itemsList}
            </div>
        </div>
    );
}

Menu.propTypes = {
    layout: PropTypes.oneOf(['classic', 'topbar']),
    withIcons: PropTypes.bool,
    items: PropTypes.array,
    onClick: PropTypes.func,
};

Menu.defaultProps = {
    layout: 'classic',
    withIcons: false,
    items: [],
    onClick: () => { },
};

export default Menu;
